import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I began writing code in 2017 while constructing a 3D printer.  I have been developing my coding skills in my free time as I further my education at The University of Alabama.
              <br />
              <br />I am fluent in:
              <i>
                <b className="purple"> C, Java, and Python. </b>
              </i>
              <br/> With experience using:
              <b className="purple"> Swift, C#, HTML, CSS, Javascript, and SQL. </b>
              <br />
              <br />
              My field of interest is: &nbsp;
              <i>
                <b className="purple">Software Engineering,  </b> and
                also in areas related to developing{" "}
                <b className="purple">
                  embeded systems and hardware adaptation.
                </b>
             </i>
              <br />
              <br />
              
              <br />
              
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/tkadams1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/taylor-adams09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
